'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIErrorMessage = require('UIComponents/error/UIErrorMessage');

var _UIErrorMessage2 = _interopRequireDefault(_UIErrorMessage);

var _images = require('MeetingsBase/constants/images');

var _utils = require('MeetingsLib/utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _React2.default.createClass({
  displayName: 'Error',

  propTypes: {
    profile: _React.PropTypes.instanceOf(_UserProfile2.default),
    isSalesStarter: _React.PropTypes.bool,
    isInvalidDomainError: _React.PropTypes.bool,
    meetingCreationFailed: _React.PropTypes.bool,
    bookInfoFailed: _React.PropTypes.bool,
    userProfileLoadSuccess: _React.PropTypes.bool
  },

  handleReloadPage: function handleReloadPage() {
    document.location.reload(true);
  },
  renderDescription: function renderDescription(message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _React2.default.createElement(
      'p',
      { className: 'error-description', key: 'description' },
      _React2.default.createElement(_I18nReact2.default, { message: message, options: options })
    );
  },
  renderEmail: function renderEmail() {
    var profile = this.props.profile;


    return _React2.default.createElement(
      'div',
      { className: 'error-email', key: 'email' },
      _React2.default.createElement(_I18nReact2.default, {
        message: 'error.email',
        options: { fullName: (0, _utils.getLongDisplayName)(profile) }
      }),
      _React2.default.createElement(
        _UILink2.default,
        { href: 'mailto:' + profile.email },
        profile.email
      )
    );
  },
  renderRetryButton: function renderRetryButton() {
    return _React2.default.createElement(
      'div',
      { className: 'error-button-container', key: 'retry' },
      _React2.default.createElement(
        _UIButton2.default,
        {
          use: 'tertiary',
          className: 'error-button',
          onClick: this.handleReloadPage
        },
        _React2.default.createElement(_I18nReact2.default, { message: 'error.button' })
      )
    );
  },
  renderImage: function renderImage(src) {
    return _React2.default.createElement(_UIImage2.default, { key: 'image', className: 'error-image', src: src });
  },
  renderHeader: function renderHeader(message) {
    return _React2.default.createElement(
      'h4',
      { className: 'm-bottom-2', key: 'header' },
      _React2.default.createElement(_I18nReact2.default, { message: message })
    );
  },
  renderErrorWithReload: function renderErrorWithReload() {
    return _React2.default.createElement(
      _UIErrorMessage2.default,
      { title: this.renderHeader('error.general.header') },
      this.renderDescription('error.general.retryDescription'),
      this.renderRetryButton(),
      this.renderEmail()
    );
  },
  renderDowngradedLink: function renderDowngradedLink() {
    return _React2.default.createElement(
      'div',
      { className: 'link-not-found' },
      this.renderImage(_images.images.MEETINGS_LINK_CREATED),
      this.renderHeader('error.downgraded.header'),
      this.renderDescription('error.downgraded.description'),
      this.renderEmail()
    );
  },
  renderLinkNotFound: function renderLinkNotFound() {
    return _React2.default.createElement(
      _UIErrorMessage2.default,
      {
        className: 'link-not-found',
        title: this.renderHeader('error.general.header')
      },
      this.renderDescription('error.general.genericDescription')
    );
  },
  renderDifferentMessages: function renderDifferentMessages() {
    var _props = this.props,
        meetingCreationFailed = _props.meetingCreationFailed,
        userProfileLoadSuccess = _props.userProfileLoadSuccess,
        bookInfoFailed = _props.bookInfoFailed,
        isInvalidDomainError = _props.isInvalidDomainError,
        isSalesStarter = _props.isSalesStarter;


    if (meetingCreationFailed) {
      return this.renderErrorWithReload();
    }
    if (userProfileLoadSuccess && bookInfoFailed && !isInvalidDomainError && !isSalesStarter) {
      return this.renderDowngradedLink();
    }
    return this.renderLinkNotFound();
  },
  render: function render() {
    return _React2.default.createElement(
      'div',
      { className: 'meetings-error text-center' },
      this.renderDifferentMessages()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/Error.js
// module id = 495
// module chunks = 0